module.exports = require('./ascii-table')